import { ArrowUp } from "lucide-react";
import { scrollToId } from "../lib/smooth";
import { useLang } from "../lib/lang";

export const Footer = () => {
  const { tr } = useLang();
  return (
    <footer data-testid="footer" className="overflow-hidden border-t border-white/10 px-4 pt-16 sm:px-6 lg:px-8">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-6 font-mono text-xs uppercase tracking-[0.2em] text-zinc-400">
        <span>© 2026 Camila Eterovic</span>
        <span>{tr({ es: "Diseñado con alma — Nueva York", en: "Designed with soul — New York" })}</span>
        <button data-testid="footer-back-to-top" onClick={() => scrollToId("top")} className="flex items-center gap-2 text-white hover:text-[var(--acid)]">
          {tr({ es: "Volver arriba", en: "Back to top" })} <ArrowUp size={14} />
        </button>
      </div>
      <div className="mx-auto mt-10 max-w-7xl select-none text-center font-name text-[24vw] italic leading-[0.8] tracking-[-0.04em] text-[var(--surface-2)] lg:text-[19rem]">
        Eterovic
      </div>
    </footer>
  );
};
